/**
 * Supabase client singleton. Imported anywhere we need to talk to Supabase Auth,
 * Postgres, or call Edge Functions.
 *
 * Anon key is public by design — RLS gates real data access. See PRD §10 S2.
 */

import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Won't crash — but auth-gated routes will fail. The MockBanner surfaces this in the UI.
  console.warn("[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY not set");
}

export const supabase = createClient(url ?? "http://localhost:54321", anonKey ?? "anon", {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export const isSupabaseConfigured = Boolean(url && anonKey);
